;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { m } from 'framer-motion';
import PropTypes from 'prop-types';

import styles from './SharpnessBackground.module.scss';

// Framer Motion has a bug with animating css var colors
// https://github.com/framer/motion/issues/546

const spring = {
    type: 'spring',
    damping: 60,
    stiffness: 160,
};

const SharpnessBackground = ({ activeProduct, initialColor }) => {
    return (
        <m.div
            style={{ '--initialColor': initialColor }}
            className={styles.root}
            animate={{
                backgroundColor: activeProduct?.backgroundColor || '',
            }}
            transition={spring}
        />
    );
};

SharpnessBackground.propTypes = {
    activeProduct: PropTypes.object,
    initialColor: PropTypes.string,
};

export default SharpnessBackground;
